// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2wztI","messages":"Chat_messages__2-6tK","dateDivider":"Chat_dateDivider__3eEZv"};